import { Outlet } from 'react-router-dom';
import styles from './onboarding.module.scss';

const OnboardingFlow = () => {
  return (
    <div className={styles.shell}>
      <div className={styles.canvas} aria-hidden="true">
        <span className={styles.dots} />
      </div>

      <main className={styles.stage}>
        <div className={styles.stage_inner}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default OnboardingFlow;
